var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6794 4.3335C16.584 4.3335 17.3174 5.00507 17.3174 5.8335V8.8593C18.7703 8.8335 20.3988 8.8335 22.2312 8.8335H22.2313H30.9672H30.9673C32.7997 8.8335 34.4283 8.8335 35.8812 8.8593V5.8335C35.8812 5.00507 36.6145 4.3335 37.5192 4.3335C38.4238 4.3335 39.1572 5.00507 39.1572 5.8335V8.99201C42.3006 9.22252 44.3642 9.78825 45.8804 11.1766C47.3965 12.565 48.0142 14.4548 48.266 17.3335V19.5002H4.93262V17.3335C5.18433 14.4548 5.8021 12.565 7.31821 11.1766C8.83432 9.78825 10.898 9.22252 14.0414 8.99201V5.8335C14.0414 5.00507 14.7748 4.3335 15.6794 4.3335Z",
    fill: "#007f6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.2659 30.3333V26C48.2659 24.1821 48.2385 20.9414 48.2105 19.5H4.94531C4.91736 20.9414 4.94484 24.1821 4.94484 26V30.3333C4.94484 38.5043 4.94484 42.5898 7.48253 45.1283C10.0202 47.6667 14.1046 47.6667 22.2733 47.6667H30.9375C39.1062 47.6667 43.1906 47.6667 45.7283 45.1283C48.2659 42.5898 48.2659 38.5043 48.2659 30.3333Z",
    fill: "#007f6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5996 35.75C39.5996 37.5449 38.1445 39 36.3496 39C34.5547 39 33.0996 37.5449 33.0996 35.75C33.0996 33.9551 34.5547 32.5 36.3496 32.5C38.1445 32.5 39.5996 33.9551 39.5996 35.75Z",
    fill: "#007f6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingDays);
export default __webpack_public_path__ + "static/media/working-days.b39e3e65cdcf45f18aa47c02e54f0b23.svg";
export { ForwardRef as ReactComponent };